"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_generated_exports = {};
__export(types_generated_exports, {
  isChecked: () => isChecked,
  isCheckedFailure: () => isCheckedFailure,
  isCheckedSuccess: () => isCheckedSuccess,
  isDataLicense: () => isDataLicense,
  isEmail: () => isEmail,
  isInvitationCodeAlias: () => isInvitationCodeAlias,
  isInvitationCodeId: () => isInvitationCodeId,
  isInvitationCodeRef: () => isInvitationCodeRef,
  isInvitationEmailSettings: () => isInvitationEmailSettings,
  isInvitationId: () => isInvitationId,
  isKnownUserFeature: () => isKnownUserFeature,
  isMapId: () => isMapId,
  isMapLayerId: () => isMapLayerId,
  isMessage: () => isMessage,
  isMessageLevel: () => isMessageLevel,
  isNamedEmail: () => isNamedEmail,
  isPath: () => isPath,
  isPlanId: () => isPlanId,
  isProjectAlias: () => isProjectAlias,
  isProjectBreadcrumbId: () => isProjectBreadcrumbId,
  isProjectId: () => isProjectId,
  isProjectTemplateId: () => isProjectTemplateId,
  isQualificationAlias: () => isQualificationAlias,
  isQualificationHistoryEventId: () => isQualificationHistoryEventId,
  isQualificationId: () => isQualificationId,
  isQualificationRef: () => isQualificationRef,
  isScreenName: () => isScreenName,
  isSearchResults: () => isSearchResults,
  isSemver: () => isSemver,
  isServerVersion: () => isServerVersion,
  isStripeCouponId: () => isStripeCouponId,
  isStripeCustomerId: () => isStripeCustomerId,
  isStripeInvoiceId: () => isStripeInvoiceId,
  isStripePriceId: () => isStripePriceId,
  isStripeProductId: () => isStripeProductId,
  isStripeSubscriptionId: () => isStripeSubscriptionId,
  isSubdomain: () => isSubdomain,
  isSurveyApprovedEmailSettings: () => isSurveyApprovedEmailSettings,
  isSurveyCompleteEmailSettings: () => isSurveyCompleteEmailSettings,
  isSurveyId: () => isSurveyId,
  isSurveyModuleId: () => isSurveyModuleId,
  isTeamAlias: () => isTeamAlias,
  isTeamId: () => isTeamId,
  isTimestamp: () => isTimestamp,
  isUnencryptedPassword: () => isUnencryptedPassword,
  isUrlResponse: () => isUrlResponse,
  isUserFeature: () => isUserFeature,
  isUserId: () => isUserId,
  isUuid: () => isUuid,
  isWorkspaceAccessLevel: () => isWorkspaceAccessLevel,
  isWorkspaceAlias: () => isWorkspaceAlias,
  isWorkspaceId: () => isWorkspaceId,
  isWorkspaceRef: () => isWorkspaceRef
});
module.exports = __toCommonJS(types_generated_exports);
var import_util = require("@cartographerio/util");
const isUuid = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "Uuid")(v);
};
const isSemver = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "Semver")(v);
};
const isEmail = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "Email")(v);
};
const isNamedEmail = (v) => {
  return typeof v === "object" && v != null && "name" in v && typeof v.name === "string" && "email" in v && isEmail(v.email);
};
const isScreenName = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "ScreenName")(v);
};
const isStripeCouponId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "StripeCouponId")(v);
};
const isStripeCustomerId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "StripeCustomerId")(v);
};
const isStripeInvoiceId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "StripeInvoiceId")(v);
};
const isStripeSubscriptionId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "StripeSubscriptionId")(v);
};
const isMapId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "MapId")(v);
};
const isMapLayerId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "MapLayerId")(v);
};
const isProjectId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "ProjectId")(v);
};
const isProjectAlias = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "ProjectAlias")(v);
};
const isProjectBreadcrumbId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "ProjectBreadcrumbId")(v);
};
const isProjectTemplateId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "ProjectTemplateId")(v);
};
const isQualificationId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "QualificationId")(v);
};
const isQualificationHistoryEventId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "QualificationHistoryEventId")(v);
};
const isQualificationAlias = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "QualificationAlias")(v);
};
const isQualificationRef = (v) => {
  return isQualificationId(v) || isQualificationAlias(v);
};
const isSurveyModuleId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "SurveyModuleId")(v);
};
const isSurveyId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "SurveyId")(v);
};
const isTeamId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "TeamId")(v);
};
const isTeamAlias = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "TeamAlias")(v);
};
const isWorkspaceId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "WorkspaceId")(v);
};
const isPlanId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "PlanId")(v);
};
const isStripeProductId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "StripeProductId")(v);
};
const isStripePriceId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "StripePriceId")(v);
};
const isWorkspaceAlias = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "WorkspaceAlias")(v);
};
const isWorkspaceRef = (v) => {
  return isWorkspaceId(v) || isWorkspaceAlias(v);
};
const isSubdomain = (v) => {
  return isWorkspaceAlias(v);
};
const isUserId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "UserId")(v);
};
const isKnownUserFeature = (v) => {
  return v === "ChangeIdentity" || v === "IntegrationTest" || v === "NonBillable" || v === "Mobile2Preview" || v === "Mobile2Default" || v === "EnableMobileRiverfly";
};
const isUserFeature = (v) => {
  return v === "ChangeIdentity" || v === "IntegrationTest" || v === "NonBillable" || v === "Mobile2Preview" || v === "Mobile2Default" || v === "EnableMobileRiverfly" || typeof v === "string";
};
const isUnencryptedPassword = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "UnencryptedPassword")(v);
};
const isInvitationId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "InvitationId")(v);
};
const isInvitationCodeId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "InvitationCodeId")(v);
};
const isInvitationCodeAlias = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "InvitationCodeAlias")(v);
};
const isInvitationCodeRef = (v) => {
  return isInvitationCodeId(v) || isInvitationCodeAlias(v);
};
const isDataLicense = (v) => {
  return v === "Default" || v === "CcBy4" || v === "CcByNd4" || v === "CcBySa4" || v === "CcByNc4" || v === "CcByNcNd4" || v === "CcByNcSa4" || v === "Ogl3";
};
const isPath = (v) => {
  return Array.isArray(v) && v.every((i) => typeof i === "string" || typeof i === "number");
};
const isMessageLevel = (v) => {
  return v === "info" || v === "error";
};
const isMessage = (v) => {
  return typeof v === "object" && v != null && "level" in v && isMessageLevel(v.level) && "path" in v && isPath(v.path) && "text" in v && typeof v.text === "string" && (!("data" in v) || true);
};
const isTimestamp = (v) => {
  return typeof v === "object" && v != null && "type" in v && v.type === "Timestamp" && "iso8601" in v && typeof v.iso8601 === "string";
};
const isSearchResults = (isA) => (v) => {
  return typeof v === "object" && v != null && "results" in v && Array.isArray(v.results) && v.results.every((i) => isA(i)) && "total" in v && typeof v.total === "number";
};
const isServerVersion = (v) => {
  return typeof v === "object" && v != null && "name" in v && typeof v.name === "string" && "version" in v && typeof v.version === "string" && "booted" in v && isTimestamp(v.booted) && "uptime" in v && typeof v.uptime === "number";
};
const isCheckedSuccess = (isA) => (v) => {
  return typeof v === "object" && v != null && "type" in v && v.type === "CheckedSuccess" && "value" in v && isA(v.value);
};
const isCheckedFailure = (v) => {
  return typeof v === "object" && v != null && "type" in v && v.type === "CheckedFailure" && "errors" in v && Array.isArray(v.errors) && v.errors.every((i) => isMessage(i));
};
const isChecked = (isA) => (v) => {
  return isCheckedSuccess((a0) => isA(a0))(v) || isCheckedFailure(v);
};
const isUrlResponse = (v) => {
  return typeof v === "object" && v != null && "url" in v && typeof v.url === "string";
};
const isInvitationEmailSettings = (v) => {
  return typeof v === "object" && v != null && "fromCoordinator" in v && typeof v.fromCoordinator === "boolean" && (!("fromAddress" in v) || isNamedEmail(v.fromAddress) || v.fromAddress === null) && "toAddresses" in v && Array.isArray(v.toAddresses) && v.toAddresses.every((i) => isNamedEmail(i));
};
const isSurveyCompleteEmailSettings = (v) => {
  return typeof v === "object" && v != null && "toApprovers" in v && typeof v.toApprovers === "boolean" && "toAddresses" in v && Array.isArray(v.toAddresses) && v.toAddresses.every((i) => isNamedEmail(i));
};
const isSurveyApprovedEmailSettings = (v) => {
  return typeof v === "object" && v != null && "fromApprover" in v && typeof v.fromApprover === "boolean" && (!("fromAddress" in v) || isNamedEmail(v.fromAddress) || v.fromAddress === null) && "toSurveyors" in v && typeof v.toSurveyors === "boolean" && "toAddresses" in v && Array.isArray(v.toAddresses) && v.toAddresses.every((i) => isNamedEmail(i));
};
const isWorkspaceAccessLevel = (v) => {
  return v === "Full" || v === "ReadOnly" || v === "None";
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isChecked,
  isCheckedFailure,
  isCheckedSuccess,
  isDataLicense,
  isEmail,
  isInvitationCodeAlias,
  isInvitationCodeId,
  isInvitationCodeRef,
  isInvitationEmailSettings,
  isInvitationId,
  isKnownUserFeature,
  isMapId,
  isMapLayerId,
  isMessage,
  isMessageLevel,
  isNamedEmail,
  isPath,
  isPlanId,
  isProjectAlias,
  isProjectBreadcrumbId,
  isProjectId,
  isProjectTemplateId,
  isQualificationAlias,
  isQualificationHistoryEventId,
  isQualificationId,
  isQualificationRef,
  isScreenName,
  isSearchResults,
  isSemver,
  isServerVersion,
  isStripeCouponId,
  isStripeCustomerId,
  isStripeInvoiceId,
  isStripePriceId,
  isStripeProductId,
  isStripeSubscriptionId,
  isSubdomain,
  isSurveyApprovedEmailSettings,
  isSurveyCompleteEmailSettings,
  isSurveyId,
  isSurveyModuleId,
  isTeamAlias,
  isTeamId,
  isTimestamp,
  isUnencryptedPassword,
  isUrlResponse,
  isUserFeature,
  isUserId,
  isUuid,
  isWorkspaceAccessLevel,
  isWorkspaceAlias,
  isWorkspaceId,
  isWorkspaceRef
});
//# sourceMappingURL=types.generated.js.map
